import { render } from "./EditChampsLibreFamillePage.vue?vue&type=template&id=125d520a&ts=true"
import script from "./EditChampsLibreFamillePage.vue?vue&type=script&lang=ts"
export * from "./EditChampsLibreFamillePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__